export default __webpack_public_path__ + "static/media/glider4.9ed5f35e.png";